import classNames from "classnames";
import React from "react";
import { styles } from "./stretch-box.scss";


export function StretchBox({ fit, children }: StretchBox.Props)
{
    return (
        <div className={classNames(styles.stretch, fit && styles.fit)}>
            {
                (fit)
                    ? (<div>{children}</div>)
                    : (children)
            }
        </div>
    );
};

export namespace StretchBox
{
    export interface Props
    {
        fit?: boolean;
        children?: React.ReactNode;
    }
}
